import { apiStore } from '$store/api';
import type { FEATURE_FLAGS } from '@cc/common/src';
import { get } from 'svelte/store';


export function getAPIUrl() {
	const store = get(apiStore);
	return store.apiUrl;
}

export function clearAPIUrl() {
	apiStore.update((store) => {
		store.apiUrl = null;
		store.apiToken = null;
		return store;
	});
}

export type FeatureFlagsResponse = Record<keyof typeof FEATURE_FLAGS, string>;

export const queryFeatureFlags = () => {
	return fetch(`${getAPIUrl()}/api/feature-flags`, {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json'
		}
	})
		.then((res) => res.json())
		.then((res) => res as FeatureFlagsResponse);
};
